import { AUTOCOMPLETE_FIELD_TYPE, NUMERIC_RANGE_FIELD_TYPE, TEXT_FIELD_TYPE } from "../../helpers/constants";

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ModeEditOutlineOutlined from "@mui/icons-material/ModeEditOutlineOutlined";
import i18n from "../../i18n";
import { getTranslatedList } from "../../helpers/methods";


export const SERVICE_REGISTRY_TABLE_NAME = "service_registry_table"
export const SERVICE_REGISTRY_PREFIX = "service_registry"

export const SERVICE_REGISTRY_TABLE_FIELDS_CONFIG = [
  {
    name: "item",
    getValueCallback: (rowData) => rowData.item,
    label: i18n.t("table.service_registry_table.item"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "service_name",
    getValueCallback: (rowData) => rowData.service_name,
    label: i18n.t("table.service_registry_table.service_name"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "service_suplier",
    getValueCallback: (rowData) => rowData.service_suplier,
    label: i18n.t("table.service_registry_table.subcontractor"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData?.value?.service_supliers,
      isObjectOption: true,
      optionLabelKey: "subcontractor_short_name",
      addNewValue: false,
      multiple: true,
      disableClearable: true,
      style: { minWidth: "150px" },
    }),
  },
  {
    name: "service_price",
    getValueCallback: (rowData) => rowData.service_price,
    label: i18n.t("table.service_registry_table.service_price"),
    filterType: NUMERIC_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      style: { minWidth: "100px" },
    }),
    sortable: true,
  },
  {
    name: "service_unit",
    getValueCallback: (rowData) =>  i18n.t(`other.units.${rowData.service_unit}`) ,
    label: i18n.t("table.service_registry_table.unit"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options : getTranslatedList(filteringData?.value?.service_unit, "other.units."),
      isObjectOption: true,
      optionLabelKey: "name",
      addNewValue: false,
      multiple: true,
      disableClearable: true,
      style: { minWidth: "150px" },
    }),
  },
  {
    name: "service_note",
    getValueCallback: (rowData) => rowData.service_note,
    label: i18n.t("table.service_registry_table.service_note"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "edit",
    getValueCallback: (rowData, onClickEdit,  onClickCopy, hasPermission) => {
      const content = (
          <ModeEditOutlineOutlined
            onClick={(e) => onClickEdit(e, rowData.id)}
          />
      );
      return  hasPermission && rowData.service_active ? content : "";
    },
    filterType: null,
    label: i18n.t("table.service_registry_table.edit"),
    excludedFromExport: true,
    allowChangeVisibility: false,

  },
  {
    name: "copy",
    getValueCallback: (rowData, onClickEdit, onClickCopy, hasPermission) => {
      const content = (
          <ContentCopyIcon
            onClick={(e) => onClickCopy(e, rowData.id)}
          />
      );
      return  hasPermission && rowData.service_active ? content : "";
    },
    filterType: null,
    label: i18n.t("table.material_registry_table.copy"),
    excludedFromExport: true,
    allowChangeVisibility: false,

  }
];
